module.exports = __webpack_public_path__ + "static/media/icon-view-happy.6fb5e6da.svg";